export default __webpack_public_path__ + "static/media/cinepol_logo.a4cdbde7.jpg";